import ReactDOM from "react-dom/client";

import { BrowserRouter } from "react-router-dom";
import MainRoutes from "./routes.tsx";

import 'rsuite/dist/styles/rsuite-default.css';

import "./index.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <MainRoutes />
  </BrowserRouter>
);
